import styles from './pages.module.scss';
import { useSelector } from 'react-redux';
import { getBestUsers } from 'Containers/Home/store/selectors';
import WrappedSvg from 'assets/svg/wrapped/topClients.svg';

const medals = [
    { color: '#CDAA00' }, // oro
    { color: '#A0A3A8' }, // argento
    { color: '#CD7F32' }, // bronzo
  ];
  

const TopClients = ({topClients}) => {
    console.log("topClients", topClients);
    const topThree = topClients.slice(0,3);

    return (
        <div className={styles.card}>
            <img src={WrappedSvg} alt="Wrapped" className={styles.background_image} />
            <div className={styles.title_container}>
                <h1 className={styles.title}>Top 3 clienti</h1>
                <div className={styles.leaderboard}>
                    {topThree.map((item, idx) => (
                    <div key={item.id || idx} className={styles.leaderboard_item}>
                        <div
                        className={styles.medal}
                        style={{ backgroundColor: medals[idx]?.color || '#ffffff' }}
                        >
                            {idx + 1}
                        </div>
                        <div className={styles.leaderboard_info}>
                        <div className={styles.leaderboard_name}>{`${item.nome} ${item.cognome}` || 'Cliente'}</div>
                        <div className={styles.leaderboard_count}>
                            {item.totPrenotazioni ?? '0'} prenotazioni
                        </div>
                        </div>
                    </div>
                    ))}
                </div>
            </div>
        </div>
    );
}

export default TopClients;
